import { adminHttpClient } from '../commons/adminHttpClient'
import { BenefitDesignStatus } from 'domain/benefit/benefitDesignStatus'

export interface BenefitInfo {
  id?: string
  startDate: string
  endDate: string
  allowanceType?: number
  sameClassForAll?: boolean
  benefitDesignStatus?: BenefitDesignStatus
}

export const getBenefitInfo = (planPeriodId?: string): Promise<any> => {
  return adminHttpClient.get(`/AdminDashboard/BenefitInfo/${planPeriodId}`)
}
